"use client";

import dynamic from "next/dynamic";

export type Props = {
    pixelId: string;
}

export default function FacebookPixelEvents(props: Props) {
    const FacebookPixelPageEvents = dynamic(() => import("./facebook-pixel-page-events"), {ssr: false});
    
    return (
        <>
            <FacebookPixelPageEvents pixelId={props.pixelId} />
        </>
    )
}